import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingListTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Location View.Buildings List.Title",
        defaultMessage: "Buildings at this location: {buildingLength}"
    },
    backLabel: {
        id: "quoteandbind.wizard.commercial.TWIA.Location View.Buildings List.Back",
        defaultMessage: "Back"
    },
    fullAddress: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Full Address",
        defaultMessage: "Full Address"
    },
    countyLabel: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.County",
        defaultMessage: "County"
    },
    territoryCodeLabel: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Territory Code",
        defaultMessage: "Territory Code"
    },
    addBuilding: {
        id: "quoteandbind.wizard.commercial.TWIA.View Location.Add Building",
        defaultMessage: "Add Building"
    },
    buildingDescription: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Building Description",
        defaultMessage: "BUILDING DESCRIPTION"
    },
    propertyClassCode: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Property Class Code",
        defaultMessage: "PROPERTY CLASS CODE"
    },
    coverageForm: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Coverage Form",
        defaultMessage: "COVERAGE FORM"
    }
})